<template>
  <div class="biz-time">
    <!-- 结构化展示 -->
    <div
      class="biz-item"
      v-for="(item, index) in value"
      :key="index">
      <div class="show-content">{{item.bizDay | formatBizDay}}</div>
      <div class="show-content">
        <div
          class="segment"
          v-for="(segment, index) in item.bizTime"
          :key="index"
        >{{segment.begin}}-{{segment.end}}</div>
      </div>
    </div>
    <rich-button
      class="btn"
      @click="beginEdit"
      light
    >{{gettext('请选择')}}</rich-button>
    <!-- main-page -->    <!-- item-page -->
  </div>
</template>

<script type="text/ecmascript-6">
import { cloneDeep, isEmpty } from 'lodash-es'
import Page from './Page'
import MultiSelect from './MultiSelect'
import { BIZDAY_OPTIONS } from '@/consts'

// 小时 00-23
const HOUR_OPTIONS = (function (count) {
  let i = 0
  let res = []
  while (i < count) {
    let val = i < 10
      ? `0${i}`
      : `${i}`
    res.push({
      text: val,
      value: val
    })
    i++
  }
  return res
})(24)
// 分钟step=10 00-50
const MINUTES_OPTIONS = (function (count) {
  let i = 0
  let res = []
  while (i < count) {
    let val = i < 10
      ? `0${i}`
      : `${i}`
    res.push({
      text: val,
      value: val
    })
    i += 10
  }
  return res
})(59)
export default {
  name: 'bizTime',
  components: {
    Page,
    MultiSelect
  },
  props: {
    zindex: {
      type: Number,
      default: 10
    },
    value: {
      type: Array,
      required: true,
      default () {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {},
  methods: {
    isEmpty,
    beginEdit () {
      // this.$refs.mainPage.show()
      const BizTime = this.$createFullScreenBizTime({
        zindex: this.zindex,
        value: this.value
      }).show()
      BizTime.$on('confirm', (data) => {
        this.$emit('input', data)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.biz-time {
  .btn {
      font-size: $fontsize-medium;
    }
  .biz-item {
    margin-bottom: 10px;
    .show-content {
      margin-bottom: 12px;
      overflow: auto;
      font-size: $fontsize-medium;
      .segment {
        margin-right: 20px;
      }
    }
    .action-wrap {
      text-align: right;
    }
  }
  h4 {
    font-size: $fontsize-large;
    margin-bottom: 20px;
  }
  h5 {
    font-size: $fontsize-medium;
    margin-bottom: 10px;
  }
  .richic-delete {
    margin-right: 0;
  }
  .segment-edit {
    text-align: center;
    margin-bottom: 16px;
    line-height: 32Px;
    span {
      margin-right: 20px;
    }
  }
}
</style>
